"use client"

import type { PostWorkflowStatus } from "@/types/types"

type ReviewStatus = "draft" | "pending_review" | "approved" | "rejected"

type TranslateFn = (key: string) => string

export type PostStatusTagTone = "success" | "error" | "warning" | "default"

export interface PostStatusTagItem {
  label: string
  tone: PostStatusTagTone
}

interface BuildPostStatusOptions {
  status?: PostWorkflowStatus
  publishedAt?: string | null
  scheduledAt?: string | null
  reviewStatus?: ReviewStatus
}

const getUnifiedStatusItem = (status?: PostWorkflowStatus, t?: TranslateFn): PostStatusTagItem | null => {
  if (!status) return null

  switch (status) {
    case "pending":
      return { label: t?.("PostReviewPending") || "PostReviewPending", tone: "warning" }
    case "approved":
      return { label: t?.("PostReviewApproved") || "PostReviewApproved", tone: "success" }
    case "rejected":
      return { label: t?.("PostReviewRejected") || "PostReviewRejected", tone: "error" }
    case "scheduled":
      return { label: t?.("Scheduled") || "Scheduled", tone: "warning" }
    case "published":
      return { label: t?.("Published") || "Published", tone: "success" }
    case "draft":
    default:
      return { label: t?.("Draft") || "Draft", tone: "default" }
  }
}

export const buildPostStatusDisplay = (options: BuildPostStatusOptions, t?: TranslateFn): PostStatusTagItem[] => {
  const unifiedStatus = options.status || "draft"
  const unifiedItem = getUnifiedStatusItem(unifiedStatus, t)
  return unifiedItem ? [unifiedItem] : []
}

export const normalizePostStatus = (
  status: any,
  publishedAt?: string | null,
  scheduledAt?: string | null
): PostWorkflowStatus => {
  if (status && typeof status === "string") {
    const validStatuses: PostWorkflowStatus[] = [
      "draft", "pending", "approved", "rejected", "published", "scheduled"
    ]
    if (validStatuses.includes(status as PostWorkflowStatus)) {
      return status as PostWorkflowStatus
    }
  }

  if (publishedAt) return "published"
  if (scheduledAt) return "scheduled"

  return "draft"
}